export default __webpack_public_path__ + "mozantech.b7fbfca.png";